import router from './router'

// const authPage = [
// ]

router.beforeEach((to, from, next) => {
  /* has token */
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
